"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _i18next = _interopRequireDefault(require("i18next"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var operators = [{
  operator: 'OR',
  description: _i18next["default"].t('search.operators.or.desc'),
  example: 'A OR B'
}, {
  operator: 'AND',
  description: _i18next["default"].t('search.operators.and.desc'),
  example: 'A AND B'
}, {
  operator: 'NOT',
  description: _i18next["default"].t('search.operators.not.desc'),
  example: 'NOT A OR B'
}];

var _default = function _default(_ref) {
  var isOpen = _ref.isOpen,
      toggle = _ref.toggle;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: isOpen,
    onClose: toggle,
    PaperProps: {
      style: {
        width: 800,
        maxWidth: 800
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center text-2xl font-semibold text-dark"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, "Search Operators"), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: "float-right",
    onClick: toggle
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), /*#__PURE__*/_react["default"].createElement("table", {
    border: true,
    className: "w-full mt-10 font-semibold text-gray-medium"
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, operators.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      className: "border-b first:border-t"
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: "p-4 border-l border-r text-gray-dark"
    }, item.operator), /*#__PURE__*/_react["default"].createElement("td", {
      className: "p-4 border-r"
    }, item.description), /*#__PURE__*/_react["default"].createElement("td", {
      className: "border-r p-4"
    }, item.example));
  })))));
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map